import $ from 'jquery';
import 'bootstrap';
require('waypoints/lib/noframework.waypoints.js');
import Swiper, {SwiperOptions, Autoplay, Pagination} from "swiper"
Swiper.use([Autoplay, Pagination]);

const general = {
    "mqBreakpoints": {
      xs: 0,
      sm: 576,
      md: 768,
      lg: 992,
      xl: 1156
    },

    "waypointsHandler": function() {

        if ($(location).attr('hash')) {
            document.getElementById('js-main').classList.add('is-half');
            document.getElementById('js-main').classList.add('is-entered');
            document.getElementById('header').classList.add('--dark');
        }

        // This waypoint show title on intro whe
        let waypointText = new Waypoint({
            element: document.getElementById('js-waypoint'),
            handler: function handler(direction) {
                if (direction === 'down') {
                    document.getElementById('js-main').classList.add('is-half');
                } else {
                    document.getElementById('js-main').classList.remove('is-half');
                }
            },
            offset: '-60%'
        });

        // This waypoint switch fixed and absolute section
        let waypointIntro = new Waypoint({
            element: document.getElementById('js-waypoint'),
            handler: function handler(direction) {
                if (direction === 'down') {
                    document.getElementById('js-main').classList.add('is-entered');
                } else {
                    document.getElementById('js-main').classList.remove('is-entered');
                }
            },
            offset: '-100%'
        });

        // This waypoint switch fixed and absolute section
        let waypointMenu = new Waypoint({
            element: document.getElementById('js-waypoint'),
            handler: function handler(direction) {
                if (direction === 'down') {
                    document.getElementById('header').classList.add('--dark');
                } else {
                    document.getElementById('header').classList.remove('--dark');
                }
            },
            offset: '-175%'
        });
    },

    "spyScroll": function() {


        let scrollPoints = {
            'menu': '-200%',
            'about': '-300%',
            'envira-gallery-wrap-82': '-450%',
            'contact': '-525%',
        }

        // Define real points in percent to switch active menu item
        for (const [key, value] of Object.entries(scrollPoints)) {
            let target = $('#'+key);

            // get position of element + 2 x 100vh because scroll effet introduction
            let position = target.position().top + (2 * $(window).height());

            // Contact is not full screen so we handle menu change before
            if (target === 'contact') {
                position = position - (0.33 * $(window).height());
            }

            scrollPoints[key] = '-' + (position / $(window).height() * 100) + '%';
        }


        let tmpKeys = Object.keys(scrollPoints);

        for (const [key, value] of Object.entries(scrollPoints)) {
            window['spyscroll' + scrollPoints.key] = new Waypoint({
                element: document.getElementById('js-waypoint'),
                handler: function handler(direction) {
                    if (direction === 'down') {
                        // L
                        if (key === 'about') {
                            general.dynamicHomeHeight();
                        }

                        $('.header .nav-item').removeClass('active');
                        $('.header .nav-item a[href="#'+ key +'"]').parent().addClass('active');
                    } else {
                        $('.header .collapse .nav-item').removeClass('active');
                        if (key !== 'menu') {
                            let previous = null;
                            for(var i = 0; i < tmpKeys.length; i++) {
                                if (tmpKeys[i] === key) {
                                    previous = tmpKeys[i - 1];
                                }
                            }
                            if (previous) {
                                $('.header .nav-item a[href="#'+ previous +'"]').parent().addClass('active');
                            }
                        }
                    }
                },
                offset: value
            });
        }
    },


    "initSwiper": function() {
        var swiper = new Swiper('.swiper-container', {
            spaceBetween: 0,
            // centeredSlides: true,
            loop: true,
            autoplay: {
                delay: 25000,
                disableOnInteraction: false,
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets'
            },
        });

        swiper.on('slideChange', function() {
            $('.js-swiper-custom-nav').removeClass('active');
            $('.js-swiper-custom-nav[data-index='+(swiper.realIndex+1)+']').first().addClass('active')
        })

        $('.js-swiper-custom-nav').on('click', function(e) {
            e.preventDefault();
            if ($(window).width() < general.mqBreakpoints['md']) {
                if ($(this).hasClass('active')) {
                    swiper.slidePrev();
                } else {
                    swiper.slideNext();
                 }
            } else {
                swiper.slideTo($(this).data('index'));
            }
        })
    },


    "initMapHandler": function() {
        let script = document.createElement('script');
        let map;

        script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyCkvLpgVzUP5bAReomSQrTn9g68vaIt4Uo&callback=initMap';
        script.defer = true;

        window.initMap = function() {
            const restaurant = { lat: 49.660992, lng: 5.571860 };
            // The map, centered at Uluru
            map = new google.maps.Map(document.getElementById("map"), {
                zoom: 16,
                center: restaurant,
            });
            // The marker, positioned at Uluru
            const marker = new google.maps.Marker({
                position: restaurant,
                map: map,
                icon: '/wp-content/themes/intrepide/static/img/pin.png'
            });

            const styledMapType = new google.maps.StyledMapType(
                [
                    {
                        "featureType": "water",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#e9e9e9"
                            },
                            {
                                "lightness": 17
                            }
                        ]
                    },
                    {
                        "featureType": "landscape",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#f5f5f5"
                            },
                            {
                                "lightness": 20
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#ffffff"
                            },
                            {
                                "lightness": 17
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "geometry.stroke",
                        "stylers": [
                            {
                                "color": "#ffffff"
                            },
                            {
                                "lightness": 29
                            },
                            {
                                "weight": 0.2
                            }
                        ]
                    },
                    {
                        "featureType": "road.arterial",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#ffffff"
                            },
                            {
                                "lightness": 18
                            }
                        ]
                    },
                    {
                        "featureType": "road.local",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#ffffff"
                            },
                            {
                                "lightness": 16
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#f5f5f5"
                            },
                            {
                                "lightness": 21
                            }
                        ]
                    },
                    {
                        "featureType": "poi.park",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#dedede"
                            },
                            {
                                "lightness": 21
                            }
                        ]
                    },
                    {
                        "elementType": "labels.text.stroke",
                        "stylers": [
                            {
                                "visibility": "on"
                            },
                            {
                                "color": "#ffffff"
                            },
                            {
                                "lightness": 16
                            }
                        ]
                    },
                    {
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "saturation": 36
                            },
                            {
                                "color": "#333333"
                            },
                            {
                                "lightness": 40
                            }
                        ]
                    },
                    {
                        "elementType": "labels.icon",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "transit",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#f2f2f2"
                            },
                            {
                                "lightness": 19
                            }
                        ]
                    },
                    {
                        "featureType": "administrative",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#fefefe"
                            },
                            {
                                "lightness": 20
                            }
                        ]
                    },
                    {
                        "featureType": "administrative",
                        "elementType": "geometry.stroke",
                        "stylers": [
                            {
                                "color": "#fefefe"
                            },
                            {
                                "lightness": 17
                            },
                            {
                                "weight": 1.2
                            }
                        ]
                    }
                ]
            );

            map.mapTypes.set("styled_map", styledMapType);
            map.setMapTypeId("styled_map");
        };

        document.head.appendChild(script);
    },


    "smoothScroll": function() {
        // Select all links with hashes
        $('a[href*="#"]')
            // Remove links that don't actually link to anything
            .not('[href="#"]')
            .not('[href="#0"]')
            .click(function(event) {
                // On-page links
                if (
                    location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
                    &&
                    location.hostname == this.hostname
                ) {
                    // Figure out element to scroll to
                    var target = $(this.hash);
                    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                    // Does a scroll target exist?
                    if (target.length) {
                        // Only prevent default if animation is actually gonna happen
                        event.preventDefault();
                        $('html, body').animate({
                            scrollTop: target.offset().top
                        }, 1000, function() {
                            // Callback after animation
                            // Must change focus!
                            var $target = $(target);
                            $target.focus();
                            if ($target.is(":focus")) { // Checking if the target was focused
                                return false;
                            } else {
                                $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
                                $target.focus(); // Set focus again
                            }
                        });
                    }
                }
            });
    },


    "dynamicHomeHeight": function() {
        let home = $('.home-wrapper') ;

        if (home.length) {
            let size =  home.find('.section.--intro').height() + home.find('.section.--content').height() + $( '.section.--bg' ).height() + $('.footer').height();
            home.css('height', size);
            $('.main').css('height', size);
        }
    }
};

export default general;

(function($){
    general.initMapHandler();

    $(document).ready(function () {
        general.waypointsHandler();
        general.spyScroll();
        general.initSwiper();
        general.smoothScroll();
        general.dynamicHomeHeight();

        $( window ).resize(function() {
            general.dynamicHomeHeight();
        });
    });
})($);
